<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.modifiers') }} > {{ this.$route.query.modi_name }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="_modifier !== null"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.modifiers')"/>
            <modifier
              v-if="modifier.options.length > 0"
              :validation="validation"
              :data="modifier"
              :disabled="disabledForm"
              @data="setForm"/>
          </div>
        </section>

        <section
          v-if="items.length > 0 && modifier.name"
          :class="[{ disabled: disabledForm }]"
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems') + ' ('+assignitems.length+')'"/>
            <div class="col-md-12 row align-items-center no-padding no-margin subheader-assign">
              <div class="col no-padding">{{ $t('message.productlist') }}</div>
            </div>
            <div
              v-for="(item, index) in items"
              :key="index"
              :class="{ active: item.active}"
              class="col-md-12 row align-items-center no-padding no-margin item"
              @click="toggleAssign(item)">
              <div class="col">
                {{ item.product_name }}
              </div>
              <div class="col text-right">
                <span
                  v-for="(_item, index) in item.modifiers"
                  v-if="_item.modifier_id != _modifier.modifier_id"
                  :key="index"
                  class="comma">
                  {{ _item.modifier_name }}
                </span>
                <span
                  v-if="item.active"
                  class="comma">
                  {{ modifier.name }}
                </span>
                <i class="fas fa-check-circle"/>
                <i class="far fa-circle"/>
              </div>
            </div>
          </div>
        </section>

        <section
          v-if="!disabledForm"
          class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="validation++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5
              v-if="_modifier"
              class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'ModifierEdit',
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      items: [],
      original_items: null,

      assignitems: [],
      original_assignitems: null,

      validation: 0,

      modifier: {
        name: null,
        options: [],
        is_required: false,
        min_required_count: 0,
        max_required_count: 0,
      },
      original_modifier: null,

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      products: 'getProducts',
      _modifier: 'getModifier',
    }),
    form () {
      return {
        items: this.items,
        assignitems: this.assignitems,
        modifier: this.modifier,
      }
    },
    disabledForm () {
      return !this.hasRoleEdit
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    items: {
      handler: function (after) {
        let items = after
        this.updateAssignItems(items)
      },
      deep: true,
    },
  },
  beforeCreate: function () { // clear states

  },
  created: async function () { // call api to get data and set state
    /**
     *  validation
     */
    if (!this.$route.query.modi_id) {
      return this.$router.push({ name: 'ModifierAll' })
    }
    // get category
    let res = await this.$store.dispatch('getModifier', {
      modifier_id: this.$route.query.modi_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'ModifierAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'ModifierAll' })
    }
    /**
     *  validation success
     */

    /**
    *  set data
    */
    this.modifier.name = this._modifier.modifier_name

    for (let i in this._modifier.options) {
      let opt = this._modifier.options[i]
      this.modifier.options.push({
        modifieroption_id: opt.modifieroption_id,
        option: opt.option,
        price: this.setToCustomDigitsNumber(opt.price),
        is_invalid: null,
      })
    }
    this.modifier.is_required = this._modifier.is_required
    this.modifier.min_required_count = this._modifier.min_required_count
    this.modifier.max_required_count = this._modifier.max_required_count
    /**
    *  set data done
    */

    // get products
    await this.$store.dispatch('getProducts')
    // set items
    this.setItems(this._modifier, this.products)
    // update assignitems
    this.updateAssignItems(this.items)
    // original items
    this.original_items = this.getObject(this.items)
    // original assignitems
    this.original_assignitems = this.getObject(this.assignitems)
    // original modifier
    this.original_modifier = this.getObject(this.modifier)
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 3, [{
      'name': this.$route.query.modi_name,
      'router': {
        'name': 'ModifierEdit',
        'query': {
          modi_id: this.$route.query.modi_id,
          modi_name: this.$route.query.modi_name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 3,
      submenuAtIdx: 2,
    })
  },
  mounted: function () { // run script
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  updated: function () { // re-rendered html

  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts', 'clearModifier'])
  },
  methods: {
    toggleAssign (item) {
      if (!this.modifier.name) {
        return
      }
      item.active = !item.active
    },
    setItems (_modifier, products) {
      this.items = []
      for (let i in products) {
        let product = products[i]
        if (product.type == 'product') {
          var active = false
          if (_modifier) {
            for (let j in product.modifiers) {
              let item = product.modifiers[j]
              if (_modifier.modifier_id == item.modifier_id) {
                active = true
              }
            }
          }
          this.items.push({
            product_id: product.product_id,
            product_name: product.product_name,
            modifiers: product.modifiers,
            active: active,
          })
        }
      }
    },
    updateAssignItems (items) {
      this.assignitems = []
      for (let i in items) {
        let item = items[i]
        if (item.active) {
          this.assignitems.push({
            product_id: item.product_id,
          })
        }
      }
    },
    setForm (err, data) {
      if (!err) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      data['modifier_id'] = this._modifier.modifier_id

      if (this.assignitems.length > 0) {
        data['assign'] = this.assignitems
      }

      this.update(data)
    },
    async update (data) {
      this.isSubmitted = true
      const payload = {
        ...data,
        options: data.options.map((item, index) => {
          return {
            ...item,
            index: index,
          }
        }),
      }

      let res = await this.$store.dispatch('updateModifier', payload)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: data.modifier_name }),
          color: 'success',
          icon: 'save',
        })
        // get products
        await this.$store.dispatch('getProducts')
        // set items
        this.setItems(this._modifier, this.products)
        // update assignitems
        this.updateAssignItems(this.items)
        // original items
        this.original_items = this.getObject(this.items)
        // original assignitems
        this.original_assignitems = this.getObject(this.assignitems)
        // original modifier
        this.original_modifier = this.getObject(this.modifier)
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    async del () {
      let data = {
        modifier_id: this._modifier.modifier_id,
      }

      let res = await this.$store.dispatch('deleteModifier', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.modifier.name }),
          color: 'danger',
          icon: 'delete',
        })
        // close modal
        this.closeConfirmdeleteModal()
        // go to GoodsIssueAll page
        return this.$router.push({ name: 'ModifierAll' })
      }
    },
    openConfirmdeleteModal () {
      // open modal
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/modifier/Edit.vue